/**
 * ISO 3166-1 countries: alpha-3 (what Didit and our contracts use), alpha-2 (flags, Didit IP / PoA country codes,
 * Nominatim `country_code`) and English name. Generated from i18n-iso-countries (MIT). Includes XKK (Kosovo) and TWN
 * (Taiwan), which UN M49 lacks. Shared by the API (ISO2→ISO3 normalization of evidence) and the web app (pickers).
 */
export interface Country {
  iso3: string
  iso2: string
  name: string
}

const RAW: [string, string, string][] = [
  ['AFG', 'AF', 'Afghanistan'],
  ['ALA', 'AX', 'Aland Islands'],
  ['ALB', 'AL', 'Albania'],
  ['DZA', 'DZ', 'Algeria'],
  ['ASM', 'AS', 'American Samoa'],
  ['AND', 'AD', 'Andorra'],
  ['AGO', 'AO', 'Angola'],
  ['AIA', 'AI', 'Anguilla'],
  ['ATA', 'AQ', 'Antarctica'],
  ['ATG', 'AG', 'Antigua and Barbuda'],
  ['ARG', 'AR', 'Argentina'],
  ['ARM', 'AM', 'Armenia'],
  ['ABW', 'AW', 'Aruba'],
  ['AUS', 'AU', 'Australia'],
  ['AUT', 'AT', 'Austria'],
  ['AZE', 'AZ', 'Azerbaijan'],
  ['BHS', 'BS', 'Bahamas'],
  ['BHR', 'BH', 'Bahrain'],
  ['BGD', 'BD', 'Bangladesh'],
  ['BRB', 'BB', 'Barbados'],
  ['BLR', 'BY', 'Belarus'],
  ['BEL', 'BE', 'Belgium'],
  ['BLZ', 'BZ', 'Belize'],
  ['BEN', 'BJ', 'Benin'],
  ['BMU', 'BM', 'Bermuda'],
  ['BTN', 'BT', 'Bhutan'],
  ['BOL', 'BO', 'Bolivia'],
  ['BES', 'BQ', 'Bonaire, Sint Eustatius and Saba'],
  ['BIH', 'BA', 'Bosnia and Herzegovina'],
  ['BWA', 'BW', 'Botswana'],
  ['BVT', 'BV', 'Bouvet Island'],
  ['BRA', 'BR', 'Brazil'],
  ['IOT', 'IO', 'British Indian Ocean Territory'],
  ['BRN', 'BN', 'Brunei Darussalam'],
  ['BGR', 'BG', 'Bulgaria'],
  ['BFA', 'BF', 'Burkina Faso'],
  ['BDI', 'BI', 'Burundi'],
  ['KHM', 'KH', 'Cambodia'],
  ['CMR', 'CM', 'Cameroon'],
  ['CAN', 'CA', 'Canada'],
  ['CPV', 'CV', 'Cape Verde'],
  ['CYM', 'KY', 'Cayman Islands'],
  ['CAF', 'CF', 'Central African Republic'],
  ['TCD', 'TD', 'Chad'],
  ['CHL', 'CL', 'Chile'],
  ['CHN', 'CN', 'China'],
  ['CXR', 'CX', 'Christmas Island'],
  ['CCK', 'CC', 'Cocos (Keeling) Islands'],
  ['COL', 'CO', 'Colombia'],
  ['COM', 'KM', 'Comoros'],
  ['COG', 'CG', 'Congo'],
  ['COD', 'CD', 'Congo'],
  ['COK', 'CK', 'Cook Islands'],
  ['CRI', 'CR', 'Costa Rica'],
  ['CIV', 'CI', "Côte d'Ivoire"],
  ['HRV', 'HR', 'Croatia'],
  ['CUB', 'CU', 'Cuba'],
  ['CUW', 'CW', 'Curaçao'],
  ['CYP', 'CY', 'Cyprus'],
  ['CZE', 'CZ', 'Czechia'],
  ['DNK', 'DK', 'Denmark'],
  ['DJI', 'DJ', 'Djibouti'],
  ['DMA', 'DM', 'Dominica'],
  ['DOM', 'DO', 'Dominican Republic'],
  ['ECU', 'EC', 'Ecuador'],
  ['EGY', 'EG', 'Egypt'],
  ['SLV', 'SV', 'El Salvador'],
  ['GNQ', 'GQ', 'Equatorial Guinea'],
  ['ERI', 'ER', 'Eritrea'],
  ['EST', 'EE', 'Estonia'],
  ['SWZ', 'SZ', 'Eswatini'],
  ['ETH', 'ET', 'Ethiopia'],
  ['FLK', 'FK', 'Falkland Islands (Malvinas)'],
  ['FRO', 'FO', 'Faroe Islands'],
  ['FJI', 'FJ', 'Fiji'],
  ['FIN', 'FI', 'Finland'],
  ['FRA', 'FR', 'France'],
  ['GUF', 'GF', 'French Guiana'],
  ['PYF', 'PF', 'French Polynesia'],
  ['ATF', 'TF', 'French Southern Territories'],
  ['GAB', 'GA', 'Gabon'],
  ['GEO', 'GE', 'Georgia'],
  ['DEU', 'DE', 'Germany'],
  ['GHA', 'GH', 'Ghana'],
  ['GIB', 'GI', 'Gibraltar'],
  ['GRC', 'GR', 'Greece'],
  ['GRL', 'GL', 'Greenland'],
  ['GRD', 'GD', 'Grenada'],
  ['GLP', 'GP', 'Guadeloupe'],
  ['GUM', 'GU', 'Guam'],
  ['GTM', 'GT', 'Guatemala'],
  ['GGY', 'GG', 'Guernsey'],
  ['GIN', 'GN', 'Guinea'],
  ['GNB', 'GW', 'Guinea-Bissau'],
  ['GUY', 'GY', 'Guyana'],
  ['HTI', 'HT', 'Haiti'],
  ['HMD', 'HM', 'Heard Island and McDonald Islands'],
  ['VAT', 'VA', 'Holy See (Vatican City State)'],
  ['HND', 'HN', 'Honduras'],
  ['HKG', 'HK', 'Hong Kong'],
  ['HUN', 'HU', 'Hungary'],
  ['ISL', 'IS', 'Iceland'],
  ['IND', 'IN', 'India'],
  ['IDN', 'ID', 'Indonesia'],
  ['IRN', 'IR', 'Iran'],
  ['IRQ', 'IQ', 'Iraq'],
  ['IRL', 'IE', 'Ireland'],
  ['IMN', 'IM', 'Isle of Man'],
  ['ISR', 'IL', 'Israel'],
  ['ITA', 'IT', 'Italy'],
  ['JAM', 'JM', 'Jamaica'],
  ['JPN', 'JP', 'Japan'],
  ['JEY', 'JE', 'Jersey'],
  ['JOR', 'JO', 'Jordan'],
  ['KAZ', 'KZ', 'Kazakhstan'],
  ['KEN', 'KE', 'Kenya'],
  ['KIR', 'KI', 'Kiribati'],
  ['KOR', 'KR', 'Korea, Republic of'],
  ['XKK', 'XK', 'Kosovo'],
  ['KWT', 'KW', 'Kuwait'],
  ['KGZ', 'KG', 'Kyrgyzstan'],
  ['LAO', 'LA', "Lao People's Democratic Republic"],
  ['LVA', 'LV', 'Latvia'],
  ['LBN', 'LB', 'Lebanon'],
  ['LSO', 'LS', 'Lesotho'],
  ['LBR', 'LR', 'Liberia'],
  ['LBY', 'LY', 'Libya'],
  ['LIE', 'LI', 'Liechtenstein'],
  ['LTU', 'LT', 'Lithuania'],
  ['LUX', 'LU', 'Luxembourg'],
  ['MAC', 'MO', 'Macao'],
  ['MDG', 'MG', 'Madagascar'],
  ['MWI', 'MW', 'Malawi'],
  ['MYS', 'MY', 'Malaysia'],
  ['MDV', 'MV', 'Maldives'],
  ['MLI', 'ML', 'Mali'],
  ['MLT', 'MT', 'Malta'],
  ['MHL', 'MH', 'Marshall Islands'],
  ['MTQ', 'MQ', 'Martinique'],
  ['MRT', 'MR', 'Mauritania'],
  ['MUS', 'MU', 'Mauritius'],
  ['MYT', 'YT', 'Mayotte'],
  ['MEX', 'MX', 'Mexico'],
  ['FSM', 'FM', 'Micronesia, Federated States of'],
  ['MDA', 'MD', 'Moldova, Republic of'],
  ['MCO', 'MC', 'Monaco'],
  ['MNG', 'MN', 'Mongolia'],
  ['MNE', 'ME', 'Montenegro'],
  ['MSR', 'MS', 'Montserrat'],
  ['MAR', 'MA', 'Morocco'],
  ['MOZ', 'MZ', 'Mozambique'],
  ['MMR', 'MM', 'Myanmar'],
  ['NAM', 'NA', 'Namibia'],
  ['NRU', 'NR', 'Nauru'],
  ['NPL', 'NP', 'Nepal'],
  ['NCL', 'NC', 'New Caledonia'],
  ['NZL', 'NZ', 'New Zealand'],
  ['NIC', 'NI', 'Nicaragua'],
  ['NER', 'NE', 'Niger'],
  ['NGA', 'NG', 'Nigeria'],
  ['NIU', 'NU', 'Niue'],
  ['NFK', 'NF', 'Norfolk Island'],
  ['PRK', 'KP', 'North Korea'],
  ['MKD', 'MK', 'North Macedonia'],
  ['MNP', 'MP', 'Northern Mariana Islands'],
  ['NOR', 'NO', 'Norway'],
  ['OMN', 'OM', 'Oman'],
  ['PAK', 'PK', 'Pakistan'],
  ['PLW', 'PW', 'Palau'],
  ['PSE', 'PS', 'Palestine'],
  ['PAN', 'PA', 'Panama'],
  ['PNG', 'PG', 'Papua New Guinea'],
  ['PRY', 'PY', 'Paraguay'],
  ['PER', 'PE', 'Peru'],
  ['PHL', 'PH', 'Philippines'],
  ['PCN', 'PN', 'Pitcairn Islands'],
  ['POL', 'PL', 'Poland'],
  ['PRT', 'PT', 'Portugal'],
  ['PRI', 'PR', 'Puerto Rico'],
  ['QAT', 'QA', 'Qatar'],
  ['REU', 'RE', 'Reunion'],
  ['ROU', 'RO', 'Romania'],
  ['RUS', 'RU', 'Russia'],
  ['RWA', 'RW', 'Rwanda'],
  ['BLM', 'BL', 'Saint Barthélemy'],
  ['SHN', 'SH', 'Saint Helena'],
  ['KNA', 'KN', 'Saint Kitts and Nevis'],
  ['LCA', 'LC', 'Saint Lucia'],
  ['MAF', 'MF', 'Saint Martin (French part)'],
  ['SPM', 'PM', 'Saint Pierre and Miquelon'],
  ['VCT', 'VC', 'Saint Vincent and the Grenadines'],
  ['WSM', 'WS', 'Samoa'],
  ['SMR', 'SM', 'San Marino'],
  ['STP', 'ST', 'Sao Tome and Principe'],
  ['SAU', 'SA', 'Saudi Arabia'],
  ['SEN', 'SN', 'Senegal'],
  ['SRB', 'RS', 'Serbia'],
  ['SYC', 'SC', 'Seychelles'],
  ['SLE', 'SL', 'Sierra Leone'],
  ['SGP', 'SG', 'Singapore'],
  ['SXM', 'SX', 'Sint Maarten (Dutch part)'],
  ['SVK', 'SK', 'Slovakia'],
  ['SVN', 'SI', 'Slovenia'],
  ['SLB', 'SB', 'Solomon Islands'],
  ['SOM', 'SO', 'Somalia'],
  ['ZAF', 'ZA', 'South Africa'],
  ['SGS', 'GS', 'South Georgia and the South Sandwich Islands'],
  ['SSD', 'SS', 'South Sudan'],
  ['ESP', 'ES', 'Spain'],
  ['LKA', 'LK', 'Sri Lanka'],
  ['SDN', 'SD', 'Sudan'],
  ['SUR', 'SR', 'Suriname'],
  ['SJM', 'SJ', 'Svalbard and Jan Mayen'],
  ['SWE', 'SE', 'Sweden'],
  ['CHE', 'CH', 'Switzerland'],
  ['SYR', 'SY', 'Syrian Arab Republic'],
  ['TWN', 'TW', 'Taiwan'],
  ['TJK', 'TJ', 'Tajikistan'],
  ['TZA', 'TZ', 'Tanzania'],
  ['THA', 'TH', 'Thailand'],
  ['GMB', 'GM', 'The Gambia'],
  ['NLD', 'NL', 'The Netherlands'],
  ['TLS', 'TL', 'Timor-Leste'],
  ['TGO', 'TG', 'Togo'],
  ['TKL', 'TK', 'Tokelau'],
  ['TON', 'TO', 'Tonga'],
  ['TTO', 'TT', 'Trinidad and Tobago'],
  ['TUN', 'TN', 'Tunisia'],
  ['TUR', 'TR', 'Turkey'],
  ['TKM', 'TM', 'Turkmenistan'],
  ['TCA', 'TC', 'Turks and Caicos Islands'],
  ['TUV', 'TV', 'Tuvalu'],
  ['ARE', 'AE', 'UAE'],
  ['UGA', 'UG', 'Uganda'],
  ['GBR', 'GB', 'UK'],
  ['UKR', 'UA', 'Ukraine'],
  ['USA', 'US', 'United States'],
  ['UMI', 'UM', 'United States Minor Outlying Islands'],
  ['URY', 'UY', 'Uruguay'],
  ['UZB', 'UZ', 'Uzbekistan'],
  ['VUT', 'VU', 'Vanuatu'],
  ['VEN', 'VE', 'Venezuela'],
  ['VNM', 'VN', 'Vietnam'],
  ['VGB', 'VG', 'Virgin Islands, British'],
  ['VIR', 'VI', 'Virgin Islands, U.S.'],
  ['WLF', 'WF', 'Wallis and Futuna'],
  ['ESH', 'EH', 'Western Sahara'],
  ['YEM', 'YE', 'Yemen'],
  ['ZMB', 'ZM', 'Zambia'],
  ['ZWE', 'ZW', 'Zimbabwe'],
]

export const COUNTRIES: readonly Country[] = RAW.map(([iso3, iso2, name]) => ({ iso3, iso2, name }))

const BY_ISO3 = new Map(COUNTRIES.map((c) => [c.iso3, c]))
const BY_ISO2 = new Map(COUNTRIES.map((c) => [c.iso2, c]))

/** Every ISO3 code of the list (250). */
export const ALL_COUNTRY_ISO3: readonly string[] = COUNTRIES.map((c) => c.iso3)

export const countryByIso3 = (iso3: string | null | undefined): Country | undefined =>
  iso3 ? BY_ISO3.get(iso3.trim().toUpperCase()) : undefined

export const isKnownCountryIso3 = (iso3: string | null | undefined): boolean => countryByIso3(iso3) !== undefined

/**
 * ISO 3166-1 alpha-2 or alpha-3 (any case) → alpha-3, or null when unknown. Didit reports ISO3 for documents and
 * ISO2 for IP / PoA addresses; Nominatim reports lower-case ISO2. Evidence is always normalized through this.
 */
export function normalizeCountryIso3(code: string | null | undefined): string | null {
  if (!code) return null
  const c = code.trim().toUpperCase()
  if (c.length === 3) return BY_ISO3.has(c) ? c : null
  if (c.length === 2) return BY_ISO2.get(c)?.iso3 ?? null
  return null
}

/** Regional-indicator emoji flag from an alpha-2 code. */
export const flagEmoji = (iso2: string): string =>
  String.fromCodePoint(...[...iso2.toUpperCase()].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65))

/** "🇪🇸 Spain" for an ISO3 code; falls back to the code itself. */
export const countryLabel = (iso3: string | null | undefined): string => {
  const c = countryByIso3(iso3)
  return c ? `${flagEmoji(c.iso2)} ${c.name}` : (iso3 ?? '')
}

/** English name for an ISO3 code (falls back to the code). */
export const countryName = (iso3: string | null | undefined): string => countryByIso3(iso3)?.name ?? iso3 ?? ''
